import { html, nothing } from "lit";
import type { ArtifactCheckpoint } from "../controllers/session-artifacts-review.ts";

export type ChatCheckpointsPanelProps = {
  checkpoints: ArtifactCheckpoint[];
  loading?: boolean;
  busy?: boolean;
  collapsed?: boolean;
  onToggleCollapsed?: () => void;
  onRefresh?: () => void;
  onRestore?: (sinceTs: number) => void;
};

export function renderChatCheckpointsPanel(props: ChatCheckpointsPanelProps) {
  if (props.checkpoints.length === 0 && !props.loading) {
    return nothing;
  }
  const collapsed = props.collapsed === true;

  return html`
    <div class="chat-checkpoints" role="region" aria-label="Session checkpoints">
      <div class="chat-checkpoints__header">
        <button
          type="button"
          class="chat-checkpoints__toggle"
          aria-expanded=${!collapsed}
          @click=${props.onToggleCollapsed}
        >
          Checkpoints
        </button>
        ${
          props.onRefresh
            ? html`
              <button
                type="button"
                class="btn subtle btn--sm"
                ?disabled=${props.loading}
                @click=${props.onRefresh}
              >
                Refresh
              </button>
            `
            : nothing
        }
      </div>
      ${
        collapsed
          ? nothing
          : html`
            ${
              props.loading
                ? html`
                    <p class="muted chat-checkpoints__empty">Loading…</p>
                  `
                : props.checkpoints.length === 0
                  ? html`
                      <p class="muted chat-checkpoints__empty">No file checkpoints yet.</p>
                    `
                  : html`
                    <ul class="chat-checkpoints__list">
                      ${props.checkpoints.map(
                        (cp) => html`
                          <li class="chat-checkpoints__item">
                            <div>
                              <div class="chat-checkpoints__label">${cp.label}</div>
                              <div class="chat-checkpoints__meta muted">
                                ${cp.paths.length} file${cp.paths.length === 1 ? "" : "s"}
                              </div>
                            </div>
                            ${
                              props.onRestore
                                ? html`
                                  <button
                                    type="button"
                                    class="btn subtle btn--sm"
                                    ?disabled=${props.busy}
                                    @click=${() => props.onRestore?.(cp.ts)}
                                  >
                                    Restore
                                  </button>
                                `
                                : nothing
                            }
                          </li>
                        `,
                      )}
                    </ul>
                  `
            }
          `
      }
    </div>
  `;
}
